import { AxiosError, AxiosHeaders, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

// let axiosInst: AxiosInstance;

const onRequest = async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
  if (!config.headers) {
    config.headers = new AxiosHeaders();
  }

  const { useAuthStore } = await import('@/modules/auth/stores/authStore');
  const authStore = useAuthStore();

  if (authStore.isTokenExpired(config.url || '', 20)) {
    await authStore.refreshLogin();
  }

  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`;
  }

  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const onResponseError = async (error: AxiosError): Promise<any> => {
  return Promise.reject(error);
};

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  // axiosInst = axiosInstance;
  return axiosInstance;
}
